import React from 'react'
import { Video, AddUser, Settings } from '../icons'
import { useChat } from '../contexts/ChatContext'
import { useNav } from '../contexts/NavContext'

const MainNav = () => {
  const { cChat } = useChat()
  const { toggleNav } = useNav()

  return (
    <nav className='flex gap-8 items-center justify-between h-24 p-8 sticky md:static top-0 bg-purple-light opacity-80'>
      <span className='font-medium text-white text-3xl tracking-wide'>{cChat.user?.displayName}</span>
      <div className='flex gap-8 items-center'>
        <img className='cursor-pointer' src={Video} alt="video icon" />
        <img src={AddUser} alt="user icon"
          className='cursor-pointer' />
        <button onClick={toggleNav} className='cursor-pointer focus:outline-none'>
          <img src={Settings} alt="settings icon" />
        </button>
      </div>
    </nav>
  )
}

export default MainNav